import { Outlet } from 'react-router-dom';
import {
  Building2,
  CalendarRange,
  ClipboardList,
  LayoutDashboard,
  Map,
  PackageSearch,
  Route,
  ScrollText,
  Timer,
  UserPlus,
  Users,
} from 'lucide-react';
import { AppShell, type NavItem } from '~/components/layout/app-shell';

const ITEMS: NavItem[] = [
  { to: '/admin', label: 'Tableau de bord', icon: LayoutDashboard, end: true },
  { to: '/admin/interventions', label: 'Interventions', icon: ClipboardList },
  { to: '/admin/planning', label: 'Planning', icon: CalendarRange },
  { to: '/admin/carte', label: 'Carte des tournees', icon: Route },
  { to: '/admin/zones', label: 'Zones geographiques', icon: Map },
  { to: '/admin/modeles', label: 'Modeles de planification', icon: Timer },
  { to: '/admin/utilisateurs', label: 'Utilisateurs', icon: Users },
  { to: '/admin/catalogue', label: 'Catalogue', icon: PackageSearch },
  { to: '/admin/liste-attente', label: "Liste d'attente", icon: UserPlus },
  { to: '/admin/societe', label: 'Societe', icon: Building2 },
  { to: '/admin/audit', label: "Journal d'audit", icon: ScrollText },
];

export function AdminLayout() {
  return (
    <AppShell items={ITEMS} title="Administration">
      <Outlet />
    </AppShell>
  );
}
